module.exports = __webpack_public_path__ + "media/images/favicon-75d026381d7ed27671a547d6bab67bfb.ico";